import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, RefreshCw, Trash2 } from "lucide-react";
import { api, apiError, imgUrl } from "@/lib/api";

export default function ImageField({ value, onChange, testId, compact = false }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/admin/upload", fd);
      onChange(r.data.url);
      toast.success("Image uploaded");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const btnCls = "inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.12em] border border-[#E5E5E2] px-3 py-2 hover:border-[#1A1A1A] transition-colors";

  return (
    <div data-testid={testId}>
      <input ref={fileRef} type="file" accept="image/*" hidden data-testid={`${testId}-input`}
        onChange={(e) => upload(e.target.files[0])} />
      {value ? (
        <div className="flex items-center gap-3">
          <img src={imgUrl(value)} alt="Uploaded" data-testid={`${testId}-preview`}
            className={`${compact ? "w-14 h-14" : "w-24 h-24"} object-cover border border-[#E5E5E2]`} />
          <div className="flex flex-col gap-1.5">
            <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading}
              data-testid={`${testId}-replace`} className={btnCls}>
              <RefreshCw size={11} /> {uploading ? "Uploading…" : "Replace"}
            </button>
            <button type="button" onClick={() => onChange("")} data-testid={`${testId}-delete`}
              className={`${btnCls} text-red-500`}>
              <Trash2 size={11} /> Delete
            </button>
          </div>
        </div>
      ) : (
        <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading}
          data-testid={`${testId}-upload`}
          className={`${btnCls} ${compact ? "" : "w-full justify-center py-4 border-dashed"} disabled:opacity-50`}>
          <ImagePlus size={13} /> {uploading ? "Uploading…" : "Upload Image"}
        </button>
      )}
    </div>
  );
}
